import React, { useEffect, useRef, useState } from 'react';
import { useNavigation } from '../../utils/redirectUtils';
import { trackPostHogEvent } from '../../utils/posthogUtils';
import Pricing from '../../data/Pricing';
import CyclingText from './CyclingText';
import styles from './NewHero.module.css';
import heroImg from '../../assets/hero-image.webp';
import ssHeroImg1 from '../../assets/ss-landing-hero-img-1.webp';

function OriginalHero({ safeSource, switchAndSaveSource }) {
    const [isVisible, setIsVisible] = useState(false);
    const [prices, setPrices] = useState(null);
    const elementRef = useRef(null);
    const navigate = useNavigation();

    // Decide switchAndSave image or regular hero image based on source
    let heroImage = heroImg;
    if (switchAndSaveSource) {
        heroImage = ssHeroImg1;
    }

    const weightLossPhrases = [
        "Weight Loss",
        "Body Transformation", 
        "Metabolic Reset",
        "Lifestyle Change",
        "Wellness Revolution"
    ];
    
    const handleGetStarted = () => {
        
        // Track submit event
        trackPostHogEvent('landing_page_submitted', {
            selected: 'get_started',
            to_path: '/interview'
        });

        navigate('/interview');
    }

    useEffect(() => {
        const loadPrices = async () => {
            const pricing = Pricing();
            const priceData = await pricing.getPrices();
            setPrices(priceData);
        };
        
        loadPrices();

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        let currentElement = elementRef.current;
        if (currentElement) {
            observer.observe(currentElement);
        }
        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, []);

    return (
        <div
            className={styles.heroContainer}
            style={{ '--hero-bg-image': `url(${heroImage})` }}
        >
            <section className={styles.hero}>
                <div ref={elementRef} className={styles.heroText}>
                    <div className={styles.heroTopLine + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        <span className={styles.heroSafe}>{safeSource ? 'Guided Medical Weight Loss' : 'Safe Effective Proven GLP-1'}</span>
                    </div>
                    <div className={styles.heroWeight + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        <CyclingText phrases={weightLossPhrases} className={styles.cyclingWeight} />
                    </div>
                    <div className={styles.heroJourney + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        Your Journey Starts Here
                    </div>
                    <div className={styles.heroSubtext + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        <div className={styles.bullet}>
                            <div className={styles.check}></div>
                            <span>{switchAndSaveSource ? 'Join TB2 and your third month is FREE' : 'Minutes from approval'}</span>
                        </div>
                        <div className={styles.bullet}>
                            <div className={styles.check}></div>
                            <span>No telehealth visit required for most prescriptions</span>
                        </div>
                        <div className={styles.bullet}>
                            <div className={styles.check}></div>
                            <span>Real people, like you, are losing 15-26% of their body weight</span>
                        </div>
                    </div>
                    <div className={styles.buttonContainer}>
                        <div className={styles.heroButton} onClick={handleGetStarted}>
                            Get Started
                        </div>
                    </div>
                    <div className={styles.secondaryImageContainer}>
                        <img src={heroImage} alt="Hero" className={styles.secondaryHeroImage} />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default OriginalHero;
